import { useFormContext, FieldValues, Path } from 'react-hook-form';
import { TextArea } from '@radix-ui/themes';
import { TextInputConfig } from '../../types';
import { FieldWrapper } from '../FieldWrapper';

export const TextAreaField = <TFormValues extends FieldValues>({
    config,
}: {
    config: TextInputConfig<TFormValues>;
}) => {
    const { register } = useFormContext<TFormValues>();

    return (
        <FieldWrapper config={config}>
            <TextArea
                placeholder={config.placeholder}
                {...register(
                    config.name as Path<TFormValues>,
                    config.validation,
                )}
                resize='vertical'
                style={{ maxHeight: '270px' }}
            />
        </FieldWrapper>
    );
};
